<div class="flex flex-row felx-wrap gap-2">
    @if (invoiceType()?.Series != undefined) {
        <div class="flex flex-col gap-1">
            <div class="flex flex-row gap-2">
                <label class="w-5rem label-active-color w-[50px]">Σειρά:</label>
                <label>{{ invoiceType()?.Series }}</label>
            </div>
            @if (invoiceType()?.AA != undefined) {
                <div class="flex flex-row gap-2">
                    <label class="w-5rem label-active-color w-[50px]"
                        >Αριθμός:</label
                    >
                    <label>{{ invoiceType()?.AA }}</label>
                </div>
            }
        </div>
    }

    @if (invoiceType()?.Response?.InvoiceMark != undefined) {
        <div class="flex flex-col gap-1">
            <div class="flex flex-row gap-2">
                <label class="w-[65px] label-active-color">Μ.ΑΡ.Κ:</label>
                <label>
                    <!-- {{ invoiceType()?.Response?.InvoiceMark }} -->
                    @if (invoiceType()?.Response?.InvoiceMark == 0) {
                        Σε αναμονή Πληρωμής μέσω POS
                    } @else {
                        {{ invoiceType()?.Response?.InvoiceMark ?? 'N/A' }}
                    }
                </label>
            </div>
            @if (
                invoiceType()?.DCLCorrelationResponse?.ResponseDate != undefined
            ) {
                <div class="flex flex-row gap-2">
                    <label class="w-[65px] label-active-color"
                        >Συσχέτιση:</label
                    >
                    <label>{{
                        invoiceType()?.DCLCorrelationResponse?.ResponseDate
                            | zDate: dt.DATETIME_SHORT_WITH_SECONDS
                    }}</label>
                </div>
            }
        </div>
    }
</div>
